import { InfoPanelHeader } from './InfoPanelHeader';
import { Flex } from 'foundations-components/components/Flex';
import { InfoGridRow } from './InfoGridRow';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TicketInfoGrid = ({
  ticketId,
  ticket,
  configuredTicketDetailProperties,
  loading,
  error,
  refetchTicket,
  showInfoPanelHeader = true
}) => {
  const handleTryAgain = () => {
    void refetchTicket();
  };
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      inlineSize: "100%",
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        "aria-label": I18n.text('customer-portal-app.loading')
      })
    });
  }
  if (error) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      paddingInlineEnd: "400",
      alignItems: "center",
      justifyContent: "center",
      gap: "400",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "body-100",
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.ticketInfoPanel.error"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: "body-100",
          color: "text-core-subtle",
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.ticketInfoPanel.refreshPage"
          })
        })]
      }), /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleTryAgain,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.ticketInfoPanel.tryAgain"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    color: "text-core-default",
    children: [showInfoPanelHeader && /*#__PURE__*/_jsx(InfoPanelHeader, {
      ticketId: ticketId
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      marginBlockStart: showInfoPanelHeader ? '400' : '0',
      paddingInlineEnd: "400",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "400",
        children: configuredTicketDetailProperties === null || configuredTicketDetailProperties === void 0 ? void 0 : configuredTicketDetailProperties.map(configuredTicketDetailProperty => /*#__PURE__*/_jsx(InfoGridRow, {
          configuredProperty: configuredTicketDetailProperty,
          ticket: ticket
        }, configuredTicketDetailProperty.propertyName))
      })
    })]
  });
};